import { observable, decorate, computed, toJS } from "mobx"
import { SurveyTypeURL } from "../../Enums/constants"
import { IDENTITY_CONFIG_LOCAL, IDENTITY_CONFIG_LIVE, IDENTITY_CONFIG_INTRA } from "../../Enums/authConstants"

class SharedStore {
    showHelpModal = false;
    showLogoutModal = false;
    showPrintModal = false;
    showAdminPanel = false;
    showCommentModal = false;
    showErrorCommentModal = false;
    showSurveyPreparerModal = false;
    loadingErrorSummaryDone = true;
    questionMode = false;
    analystMode = false;
    developerMode = false;

    lockSurvey = false;
    currentDataYear = 0;
    bundledLDI = 0;
    mandateRegions = {}
    mandateSubstyles = {}

    cultureIdentifier = "en-us";

    get surveyTypeUrl() {
        if (window.location.href.includes("/dc")) { //any alternative for this
            return SurveyTypeURL.DC
        } else if (window.location.href.includes("/pabs")) {
            return SurveyTypeURL.PABS
        } else if (window.location.href.includes("/pabsuk")) {
            return SurveyTypeURL.PABS_UK
        } else if (window.location.href.includes("/pabslg")) {
            return SurveyTypeURL.PABS_LG
        } else if (window.location.href.includes("/db")) {
            return SurveyTypeURL.DB
        } else if (window.location.href.includes("/ibs/home")) {
            return SurveyTypeURL.IBS
        } else {
            return ""
        }
    }
    get identityConfig() {
        if (process.env.REACT_APP_IDENTITY === "IDENTITY_CONFIG_LOCAL") {
            return IDENTITY_CONFIG_LOCAL;
        }
        else if (process.env.REACT_APP_IDENTITY === "IDENTITY_CONFIG_INTRA") {
            return IDENTITY_CONFIG_INTRA;
        }
        else if (process.env.REACT_APP_IDENTITY === "IDENTITY_CONFIG_LIVE") {
            return IDENTITY_CONFIG_LIVE;
        }
        else {
            return null;
        }
    }

}

decorate(SharedStore, {
    showHelpModal: observable,
    showLogoutModal: observable,
    showPrintModal: observable,
    showAdminPanel: observable,
    showCommentModal: observable,
    cultureIdentifier: observable,
    currentDataYear: observable,
    bundledLDI: observable,
    mandateRegions: observable,
    mandateSubstyles: observable,
})

export default new SharedStore()